import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

const useSelectedCustomers = (): string[] => {
  const [searchParameters] = useSearchParams();
  return useMemo(() => searchParameters.getAll('customer'), [searchParameters]);
};

export default useSelectedCustomers;
